import Typography from "@material-ui/core/Typography";
import React from "react";

export const FolderBreadcrumbItem = ({
    folder,
    currentId
}: any) => {
    return folder.id === currentId ?
               (<Typography color="textPrimary" variant="body1">{folder.name}</Typography>) :
               (<Typography variant="body2" color="inherit">{folder.name}</Typography>)
};
